import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwitcherComponent } from './switcher.component';
import { IconModule } from '../icon/icon.module';
import { TextModule } from '../text/text.module';
@NgModule({
  declarations: [SwitcherComponent],
  imports: [CommonModule, IconModule, TextModule],
  exports: [SwitcherComponent],
})
export class SwitcherModule {}
